import React from "react";
import "./PrivacyPolicy.css"; // custom CSS file

const Privacypolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h2 className="privacy-title">Privacy Policy</h2>
        <p>
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You. We use Your Personal data to provide and improve the
          Service. By using the Service, You agree to the collection and use of
          information in accordance with this Privacy Policy.
        </p>

        <h3>Security of Your Personal Data</h3>
        <p>
          The security of Your Personal Data is important to Us, but remember
          that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While We strive to use commercially
          acceptable means to protect Your Personal Data, We cannot guarantee
          its absolute security.
        </p>

        <h3>Children's Privacy</h3>
        <p>
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from anyone
          under the age of 13. If You are a parent or guardian and You are aware
          that Your child has provided Us with Personal Data, please contact Us.
          If We become aware that We have collected Personal Data from anyone
          under the age of 13 without verification of parental consent, We take
          steps to remove that information from Our servers.
        </p>
        <p>
          If We need to rely on consent as a legal basis for processing Your
          information and Your country requires consent from a parent, We may
          require Your parent's consent before We collect and use that
          information.
        </p>

        <h3>Links to Other Websites</h3>
        <p>
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party's site. We strongly advise You to review the Privacy
          Policy of every site You visit. We have no control over and assume no
          responsibility for the content, privacy policies or practices of any
          third party sites or services.
        </p>

        <h3>Changes to this Privacy Policy</h3>
        <p>
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page. You are
          advised to review this Privacy Policy periodically for any changes.
          Changes to this Privacy Policy are effective when they are posted on
          this page.
        </p>

        <h3>Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, You can contact us:</p>
        <ul>
          <li>
            <strong>By email:</strong> info@rdegi.com
          </li>
          <li>
            <strong>By phone:</strong> +91 7845298544
          </li>
        </ul>

        <hr />

        <h3>Definitions</h3>
        <ul>
          <li>
            <strong>Account:</strong> A unique account created for You to access
            our Service or parts of our Service.
          </li>
          <li>
            <strong>Affiliate:</strong> An entity that controls, is controlled
            by, or is under common control with a party.
          </li>
          <li>
            <strong>Company:</strong> Refers to RDEGI, 11/278 B, 2nd floor, S S
            Koil street, Paramakudi, Tamil Nadu - 623707.
          </li>
          <li>
            <strong>Cookies:</strong> Small files placed on Your device
            containing browsing details and preferences.
          </li>
          <li>
            <strong>Country:</strong> Tamil Nadu, India.
          </li>
          <li>
            <strong>Device:</strong> Any device that can access the Service such
            as a computer, cellphone, or tablet.
          </li>
          <li>
            <strong>Personal Data:</strong> Information that relates to an
            identified or identifiable individual.
          </li>
          <li>
            <strong>Service:</strong> Refers to the Website.
          </li>
          <li>
            <strong>Website:</strong> Refers to RDEGI, accessible from{" "}
            <a href="http://onlinestore.staging-rdegi.com/" target="_blank" rel="noreferrer">
              onlinestore.staging-rdegi.com
            </a>
            .
          </li>
          <li>
            <strong>You:</strong> The individual or entity accessing or using
            the Service.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Privacypolicy;
